/** Angular Imports */
import { Component } from '@angular/core';

/**
 * Reusable page template for displaying different data sets with consistent layout.
 *
 * @remarks
 * This component serves as a generic container for pages that share the same
 * structure but display different data. Use it for list/detail pages, CRUD operations,
 * or any page where only the data changes but the layout remains consistent.
 *
 * @example
 * ```typescript
 * // Route configuration
 * {
 *   path: 'users',
 *   component: DataPageComponent,
 *   data: {
 *     title: 'User Management',
 *     endpoint: '/api/users',
 *     fields: ['name', 'email', 'role']
 *   }
 * }
 * ```
 */
@Component({
    selector: 'app-data-page',
    imports: [],
    templateUrl: './data-page.component.html',
    styleUrl: './data-page.component.scss',
    standalone: true,
})
export class DataPageComponent {}
